/* eslint-disable prettier/prettier */
import React, { useState } from 'react';

import { Input } from 'app/components/ui/input';

import { Label } from 'app/components/ui/label';
import { useFormContext } from 'react-hook-form';

function PageAttributes() {
  const form = useFormContext();

  return (
    <div className=" rounded-md bg-white  dark:bg-transparent p-4">
      <h2 className="text-sm mb-2 font-semibold mb-3">Page attributes</h2>
      <Label htmlFor="order">Order</Label>
      <Input
        id="order"
        type="number"
        defaultValue={form.watch('order')}
        {...form.register('order')}
        className="mt-2"
      />
    </div>
  );
}
export default PageAttributes;
